import apiClient from "./APIClient";

// existing
export const getStatementReport = async (filter) => {
  const queryString = new URLSearchParams(filter).toString();
  try {
    const res = await apiClient.get(`/statement/report?${queryString}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching statement report:", error);
    throw error;
  }
};

// NEW — all statements for the current agent (no date range required)
export const getAllStatementsForCurrentAgent = async (filter = {}) => {
  const clean = Object.fromEntries(
    Object.entries(filter).filter(
      ([, v]) => v !== null && v !== undefined && v !== ""
    )
  );
  const queryString = new URLSearchParams(clean).toString();
  try {
    const res = await apiClient.get(
      `/statement/all${queryString ? `?${queryString}` : ""}`
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching all statements for current agent:", error);
    throw error;
  }
};